import { from, Observable, of, switchMap } from 'rxjs';
import { StartupState } from '../startup.state';
import { inject } from '@angular/core';
import { StartupStep } from '../startup-step';
import { Log, META_TOKEN, MetaProvider } from '@core';

export class MetaInitStep extends StartupStep {
  private readonly metaProvider: MetaProvider = inject(META_TOKEN);

  executeStep(state: StartupState): Observable<StartupState> {
    this.logger.log(Log.Startup, { message: 'MetaInitStep START' });

    return from(this.metaProvider.initialize()).pipe(
      switchMap(() => {
        this.logger.log(Log.Startup, { message: 'MetaInitStep COMPLETED' });
        return of(state);
      })
    );
  }
}
